import React, { useEffect } from 'react';
import { getVar } from '@package/helpers/utils';

const CustomCSS = () => {
  var customCssPath = getVar('RAZZLE_CUSTOM_CSS_PATH');

  useEffect(() => {
    // Don't create link if path is undefined or empty
    if (!customCssPath) {
      return;
    }

    const link = document.createElement('link');
    link.href = customCssPath;
    link.rel = 'stylesheet';
    document.head.appendChild(link);
    return () => {
      document.head.removeChild(link);
    };
  }, [customCssPath]);

  return <></>;
};

export default CustomCSS;
